module.exports = "../fonts/vendor/vendor/typeface-inter/Inter Web/Inter-ThinItalic.woff2?ae26e5b1657fee0f99f86a1c266be953";